import { apiCall } from './apiCall';
import type { Environment } from '@/constants/Environments';
import EnvironmentHelper from '@/classes/EnvironmentHelper/EnvironmentHelper';

/**
 * Return the User Config settings for this user
 */
export async function getUserConfig(token: string, environment: Environment) {
  EnvironmentHelper.setEnvironment(environment.toLowerCase() as Environment);
  const url = `${EnvironmentHelper.getApiUrl()}users/config`;
  return await apiCall(url, { token, timeout: 5000 });
}
